<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				<img src="http://home.gamebrain.io/static/images/logo.png" />
			</el-col>
			<div>
				<div class="tools">
					广告投放平台
				</div>
				<div class="ads_nav">
					<a @click="open(1)" :class="active==1?'ads_nav_active':''">首页</a>
                    <a>市场洞察</a>
                    
                    <a>热门榜单</a>					
				</div>
				
			</div>
			
			<el-col :span="4" class="userinfo">
                <div class="header_other">
				    <el-tooltip class="item"  content="站内通知" placement="bottom">
				     <a @click="$router.push('/message')"><i class="fa fa-bell"></i></a>
				    </el-tooltip>					
				</div>	
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner"><i class="fa fa-user"></i><img :src="this.sysUserAvatar" /> {{sysUserName}}</span>
					<el-dropdown-menu slot="dropdown">					
						<el-dropdown-item @click.native="myset"><i class="fa fa-pencil-square-o"></i> 个人设置</el-dropdown-item>
						<el-dropdown-item divided @click.native="logout"><i class="fa fa-sign-out"></i> 退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'">
				<!--导航菜单-->
				<el-menu :default-active="$route.path" unique-opened :class="[!collapsed?'expanded':'', 'el-menu-vertical-demo']" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed">
					<template v-for="(item,index) in $router.options.routes"  v-if="!item.hidden">
						<el-submenu :index="item.path" v-if="item.leaf">
							<template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
							<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
						</el-submenu>
						<el-menu-item  v-else :index="item.path" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i>{{item.name}}</el-menu-item>
					</template>
				</el-menu>
				
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						
						
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
	</el-row>
</template>

<script>
	import { documenturl } from '../api/api';
	export default {
		data() {
			return {
				collapsed:false,
				sysUserName: '',
				sysUserAvatar: '',
				sysId:null
			}
		},
		computed:{
		  active(){
		    return this.$store.getters.getActive
		  }
		},
		methods: {
			onSubmit() {
				console.log('submit!');
			},
			handleopen() {
				//console.log('handleopen');
			},
			handleclose() {
				//console.log('handleclose');
			},
			open(val){
			  switch(val){
				case 1:
				   this.$router.push('/home');
				break;
				case 2:
				   this.$router.push('/main');
				break;
				case 3:
				   this.$router.push('/library');
				break;
				case 4:
				   this.$router.push('/report/index');
				break;
				case 5:
				   this.$router.push('/advertiser/index');
				break;
				case 6:
				   this.$router.push('/drop_panel');
				   break;
			  }
			  this.$store.commit('UpdateActive',val)
			},
			myset(){
			  this.$router.push('/admin/edit');
			},
			openDocument(){
			  window.open(documenturl)
			},
			handleselect: function (a, b) {
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					sessionStorage.removeItem('user');
					_this.$router.push('/login');
				}).catch(() => {

				});
			},
			//折叠导航栏
			collapse:function(){
				this.collapsed=!this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			}
		},
		mounted() {
			
			var user = sessionStorage.getItem('user');
			if (user) {
				user = JSON.parse(user);
				this.sysUserName = user.name || '未知';
				this.sysUserAvatar = user.avatar || 'https://img4.mukewang.com/58bfdbd700019de906400640-100-100.jpg';
				this.sysId = user.id
			}

		}
	}

</script>

<style  lang="scss">
	@import '~scss_vars';
	.el-submenu__title i,.el-menu-item{color:#222;}
	.el-menu-item i{color:#333;}
	.el-submenu__title{font-size:15px;}
	.el-menu-item.is-active {color: #3370ff;background-color: #e7efff;font-weight: 700;}
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background:#161E54;
			opacity:0.8;
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				
				height:60px;
				font-size: 22px;
				padding-left:20px;
				padding-right:20px;
				
				img {
					width: 150px;
					vertical-align: middle;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:200px;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{						
				height: 60px;
				line-height: 60px;
				font-size: 18px;
				font-weight:700;
				line-height: 60px;
				float:left;
			}
			.ads_nav{
                padding-left:70px;
                float:left;				
			}
			.ads_nav a,{			 
			  display:inline-block;
			  font-size:15px;
			  height:48px;
			  color:rgba(255, 255, 255, 0.65);
			  text-decoration: none;
			  margin-right:30px;
			  cursor:pointer;
			  padding:0px 8px;		  
			}
			.ads_nav_active,.ads_nav a:hover{color:#fff;border-bottom:2px solid #fbe555;}
			.header_other{float:left;padding-left:15%; a{ margin-left:15px;color:rgba(255,255,255,0.65);cursor:pointer; } a:hover{font-size:16px;}}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 230px;
				width: 200px;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.expanded{
				width: 200px!important;
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 200px;
				width: 200px;
			}
			.content-container {
				// background: #f1f2f7;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow-y: scroll;
				padding: 20px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// HomeIn.vue?6913df2a